import { render, staticRenderFns } from "./TimepassCardAdmin.vue?vue&type=template&id=a538f6cc&scoped=true&"
import script from "./TimepassCardAdmin.vue?vue&type=script&lang=js&"
export * from "./TimepassCardAdmin.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=a538f6cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a538f6cc",
  null
  
)

export default component.exports